<div class="d-flex justify-content-center p-y-16">
  <mat-spinner [diameter]="60" />
</div>